import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const SuccessBannerWrapper = styled.div`
    text-align: center;
    position: relative;
    margin-top: -40px;
`;

interface IColorProp {
    colorCode?: string;
}

export const BillClearedText = styled.div<IColorProp>(({ colorCode }) => ({
    color: colorCode || "#0c7266",
    fontFamily: "Sacramento",
    fontStyle: "normal",
    fontSize: "35px",
    fontWeight: 400,
    lineHeight: "normal",
    letterSpacing: "-0.3px",
}));

export const TotalAmountText = styled(Text)<IColorProp>(({ colorCode, theme }) => ({
    fontSize: "56px",
    color: colorCode || "#0c7266",
    marginTop: `calc(${theme.spacing.small} * -1)`,
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
    letterSpacing: "-0.8px",
}));

export const DividingLine = styled.div(({ theme }) => ({
    borderTop: `1px solid ${theme.colors[theme.colorMode].background_Overlay_Light}`,
    marginBottom: theme.spacing.medium,
    width: "220px",
}));

export const AmountTextWrapper = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 150px;
`;

export const StyledText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
}));
